import { post } from 'axios';
import Core6RowAjax from './Core6RowAjax';
import Core6Utilities from "./Core6Utilities";
import Core6OptionsLogic from "./Core6OptionsLogic";

export default class Core6RowDialogs {
  initialise() {
    $(document.body).on(
      'click change',
      '[data-core6-action]',
      Core6RowDialogs.rowOptionsListener,
    );

    $(document.body).on(
      'change',
      '[data-core6-action-select]',
      { thisClass: this },
      Core6RowDialogs.rowOptionsListenerSelect,
    );

    $(document.body).on(
      'click',
      '[data-core6-save-block-options]',
      (evt) => {
        const rowId = $(evt.currentTarget).attr('data-row-id');
        const blockOptions = Core6Utilities.getJQueryElement('.changeRowOptionsModal[data-row-id="' + rowId + '"] [data-core6-action]');
        Core6OptionsLogic.saveOptions(evt, blockOptions, 0, rowId, 0, 'block');
      },
    );

    $(document.body).on(
      'click',
      '[data-core6-save-pagedsliderblock-options]',
      (evt) => {
        const rowId = $(evt.currentTarget).attr('data-row-id');
        const blockOptions = Core6Utilities.getJQueryElement('.changeRowOptionsModal[data-row-id="' + rowId + '"] [data-core6-action]');
        Core6OptionsLogic.saveOptions(evt, blockOptions, 0, rowId, 0, 'pagedsliderblock');
        // Reload all paged sliders here
        //Core6RowDialogs.reloadPagedSliderBlocks();
      },
    );

    $(document.body).on(
      'click',
      '[data-core6-save-block-theme-options]',
      (evt) => {
        const rowId = $(evt.currentTarget).attr('data-row-id');
        const blockOptions = Core6Utilities.getJQueryElement('.changeBlockThemeModal[data-row-id="' + rowId + '"] [data-core6-action]');
        Core6OptionsLogic.saveOptions(evt, blockOptions, 0, rowId, 0, 'block');
      },
    );
  }

  static rowOptionsListener(evt) {
    //console.log($(this));
    const rowId = $(this).attr('data-row-id');
    const action = $(this).attr('data-core6-action');
    let value = $(this).attr('data-core6-value');
    let consumed = false;

    switch (action) {
      case 'changeBlockType':
        const destinationType = $(this).attr('data-core6-value');
        $('.confirmBlockTypeChangeModal', window.parent.document).modal('hide');
        Core6RowAjax.changeBlockType(rowId, destinationType);
        consumed = true;
        break;
      case 'changeBlockTheme':
        $(this).siblings().removeClass('selected');
        $(this).addClass('selected');
        //Core6RowAjax.changeBlockAttribute(rowId, 'theme', value, true);
        consumed = true;
        break;
      case 'changeColumnCount':
        Core6RowAjax.changeColumnCount(rowId, $(this).data('columns'));
        consumed = true;
        break;
      case 'deleteRow':
        Core6RowAjax.deleteRow(rowId);
        consumed = true;
        break;
      case 'deleteAllPagedSliderRows':
        Core6RowAjax.deleteAllPagedSliders(rowId);
        consumed = true;
        break;
      case 'cloneRow':
        Core6RowAjax.cloneRow(rowId);
        consumed = true;
        break;
      case 'cloneRowAndComponents':
        Core6RowAjax.cloneRowAndComponents(rowId);
        consumed = true;
        break;
      case 'changeRowAttribute':

        break;
      case 'changeBlockColour':
        //console.log('changeBlockColour');
        const param = $(this).data('core6-param');
        $(this).siblings().removeClass('selected');
        $(this).addClass('selected');
        //Core6RowAjax.changeBlockAttribute(rowId, param, value);
        consumed = true;
        break;
      case 'showMediaPicker':
        $(`.mediaPickerModal[data-row-id=${rowId}]`, window.parent.document).modal('show');
        consumed = true;
        break;
      default:
        // Do Nothing
        break;
    }

    if (consumed === true) {
      evt.preventDefault();
    }
  }

  static rowOptionsListenerSelect(evt) {
    //console.log('Select...');
    const rowId = $(this).data('row-id');
    const action = $(this).data('core6-action-select');
    const consumed = false;
    //console.log(action);

    if (action === 'changeBlockTypeConfirm') {
      //console.log('changeBlockTypeConfirm');
      Core6Utilities.hideModal(`.changeRowOptionsModal[data-row-id="${rowId}"]`);

      const value = $(this).val();
      const confirmTypeChangeModal = Core6Utilities.getJQueryElement(`.confirmBlockTypeChangeModal`);
      const blockTypeChangeBtn = confirmTypeChangeModal.find('.btn-primary');
      blockTypeChangeBtn.attr('data-row-id', rowId);
      blockTypeChangeBtn.attr('data-core6-value', value);
      confirmTypeChangeModal.modal('show');

      /*
      setTimeout(() => {
        confirmTypeChangeModal.modal('show');
      }, 500);*/
    }

    if (consumed === true) {
      evt.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/core6/Core6RowDialogs.js